import { render, staticRenderFns } from "./TabNoQaAnalyst.vue?vue&type=template&id=1164de18"
import script from "./TabNoQaAnalyst.vue?vue&type=script&lang=js"
export * from "./TabNoQaAnalyst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports